import { DialogM } from "@common/components/alert/dialog/Dialog"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { KeyValueItem } from "@common/components/card/KeyValueItem"
import TextM from "@common/components/text/TextM"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { activitiesService } from "@data/services/activitiesService"
import { hasRole } from "@data/utility/ability"
import { formatCalendarMoment } from "@data/utility/Utils"
import React, { useContext, useEffect, useState } from "react"
import { Pressable, View } from "react-native"
import { Badge } from "react-native-paper"
import { connect } from "react-redux"
import { boxedCardBorderStyle } from "../../../reviewer/BoxedCardBorderStyle"
import ChampionBubble from "../../champions/ChampionBubble"
import { samVariantForActivity } from "../../champions/ChampionImageM"
import MaterialModal from "../execute/MaterialDisplayModal"
import { definedMaterialSlug } from "../todo/ActivityPicker"
import ActivityGem from "./ActivityGem"
import ActivityScoringKeyValueItem from "./ActivityScoringKeyValueItem"
import { ActivityXpKeyValueItem } from "./ActivityXpKeyValueItem"
import { DoneChip } from "./DoneChip"
import ReadReviewRequestHandler from "./ReadReviewRequestHandler"
import { StepLogs } from "./StepLogs"

const SingleActivityResult = (props) => {
    const { activity, activityIdsString = "" } = props

    useEffect(() => {
        if (!activity?.is_review_read && hasRole(props.user, "student"))
            props.apiRequest(activitiesService.readReview, { id: activity?.id })
    }, [activity])

    const dimensions = useContext(DimensionsContext)

    const activityMaterial = activity?.material
    const dMaterialSlug = definedMaterialSlug(activity?.slug)
    const [isOpen, setOpen] = useState(false)
    const statusActivity = activity?.status
    const reviewComment = activity?.review_comment

    const handleShowModal = () => setOpen(!isOpen)
    const status = activity?.finished_at
        ? null
        : activity?.started_at !== null && activity?.locked_at !== null
        ? "ongoing"
        : activity?.started_at !== null && activity?.locked_at === null
        ? "started"
        : null

    const validateManually = () => {
        return statusActivity == "rejected" && hasRole(props.user, "tutor") ? (
            <>
                <View
                    style={{
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        paddingHorizontal: 10,
                        marginBottom: 10,
                        width: "100%",
                    }}
                >
                    {activity?.finished_at && (
                        <TextM
                            fontWeight="Bold"
                            color={theme.colors.light}
                            style={{
                                marginTop: 5,
                                width: dimensions?.width < 800 ? "100%" : null,
                            }}
                        >
                            {formatCalendarMoment(activity?.finished_at, true)}
                        </TextM>
                    )}
                </View>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        paddingHorizontal: 10,
                        marginBottom: 10,
                        width: "100%",
                    }}
                >
                    <TextM
                        fontSize={dimensions?.width < 800 ? 10 : 12}
                        wrap
                        style={{
                            marginBottom: 5,
                            textAlign: "left",
                            marginRight: dimensions?.width < 800 ? 15 : null,
                        }}
                        fontWeight="Bold"
                    >
                        L’activité n’aurait pas dû être rejetée ?{" "}
                        <TextM
                            fontSize={dimensions?.width < 800 ? 10 : 12}
                            fontWeight={"Bold"}
                            color={theme.colors.success}
                            onPress={() => {
                                showDialogValiderManuellement(activity)
                            }}
                        >
                            Cliquer pour la valider manuellement
                        </TextM>
                    </TextM>
                    <Pressable
                        onPress={() => {
                            showDialogValiderManuellement(activity)
                        }}
                        style={{ marginTop: -20 }}
                    >
                        <DoneChip
                            count={0}
                            status={status ?? statusActivity}
                            large
                        />
                    </Pressable>
                </View>
            </>
        ) : (
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    paddingHorizontal: 10,
                    marginBottom: 10,
                    width: "100%",
                }}
            >
                {activity?.finished_at && (
                    <TextM
                        fontWeight="Bold"
                        color={theme.colors.light}
                        style={{ marginTop: 5 }}
                    >
                        {formatCalendarMoment(activity?.finished_at, true)}
                    </TextM>
                )}
                <DoneChip count={0} status={status ?? statusActivity} large />
            </View>
        )
    }

    const handleValidateActivity = (item) => {
        props.apiRequest(activitiesService.tutorValidateActivity, {
            id: item.id,
            reviewer: props.user?.id,
        })
    }

    useApiStatus(
        activitiesService.tutorValidateActivity, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
            props.apiRequest(
                activitiesService.getActivities,
                {},
                {},
                {
                    with_logs: 1,
                    activity_ids: activityIdsString,
                }
            )
        }
    )

    const showDialogValiderManuellement = (item) => {
        DialogM.show({
            text1: "Valider l'activité",
            text2: "Veux-tu marquer cette activité comme validée ?",
            buttonText1: "Valider",
            onPress: () => handleValidateActivity(item),
            buttonText2: "Retour",
            onPressBack: () => {},
        })
    }
    return (
        <View
            style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "flex-start",
                paddingHorizontal: 5,
                backgroundColor: theme.colors.white,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                marginTop: 30,
                borderColor: theme.colors.lightMore,
                paddingVertical: 15,
                width: dimensions?.width,
                ...boxedCardBorderStyle,
            }}
        >
            <ReadReviewRequestHandler />

            <>{validateManually()}</>
            {!!activity?.gem_id && (
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "flex-end",
                        paddingHorizontal: 10,
                        marginBottom: 10,
                        width: "100%",
                        borderColor: theme.colors.lightMore,
                    }}
                >
                    <ActivityGem activity={activity} large />
                </View>
            )}
            {activity?.status === "pending_review" && (
                <ChampionBubble
                    name={"sam"}
                    variant={"main"}
                    championPosition="left"
                    texts={[
                        "Habituellement il me faut moins de 24h pour analyser ton travail",
                    ]}
                    onNextPress={() => {}}
                />
            )}
            {!activity?.is_review_read && hasRole(props.user, "student") ? (
                <View style={{ marginTop: 30, width: "100%" }}>
                    <FilledButtonM
                        color={theme.colors.accentDark}
                        mode="outlined"
                        loading={props.readReviewRequest}
                        disabled={props.readReviewRequest}
                        onPress={() => {
                            if (props.readReviewRequest) return
                            props.apiRequest(activitiesService.readReview, {
                                id: activity?.id,
                            })
                        }}
                        label="Voir l'évaluation"
                    />
                    <Badge
                        size={12}
                        style={{
                            backgroundColor: theme.colors.warning,
                            position: "absolute",
                            top: -2,
                            right: -2,
                        }}
                    />
                </View>
            ) : (
                <>
                    <ActivityXpKeyValueItem
                        activity={activity}
                        style={{ marginTop: 30 }}
                    />
                    {activity?.status === "validated" && (
                        <ActivityScoringKeyValueItem
                            activity={activity}
                            student={props.user}
                            style={{ marginTop: 20 }}
                        />
                    )}

                    {!!reviewComment && (
                        <KeyValueItem
                            keyText="COMMENTAIRE DE SAM"
                            valueComponent={
                                <ChampionBubble
                                    name={"sam"}
                                    variant={samVariantForActivity(activity)}
                                    noAnimation={true}
                                    championPosition="left"
                                    texts={[reviewComment]}
                                    onNextPress={() => {}}
                                />
                            }
                            style={{ marginTop: 20 }}
                            columnMode
                        />
                    )}
                </>
            )}

            {activityMaterial && (
                <View
                    style={{
                        marginTop: 30,
                    }}
                >
                    <FilledButtonM
                        mode={"outlined"}
                        label={"Voir " + dMaterialSlug}
                        style={{}}
                        color={theme.colors.primary}
                        icon={
                            activityMaterial?.url
                                ? "link"
                                : activityMaterial?.attachments?.length > 0
                                ? "image"
                                : "align-justify"
                        }
                        onPress={() => {
                            handleShowModal()
                        }}
                    />
                </View>
            )}

            {activity?.activity_logs &&
                activity?.steps?.map((step, index) => (
                    <StepLogs
                        step={step}
                        key={index}
                        index={index}
                        style={{ marginTop: 20 }}
                        updatedActivityEventData={
                            props.updatedActivityEventData
                        }
                        activity={activity}
                    />
                ))}

            {isOpen && (
                <MaterialModal
                    handleShowModal={handleShowModal}
                    isOpen={isOpen}
                    material={activityMaterial}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        readReviewRequest: state.api.readReview?.request,
        activityTemplates: state.data.staticData?.activity_templates,
        schoolSubjects: state.data.staticData?.school_subjects,
        user: state.data.currentUser?.object,
        updatedActivityEventData: state.activity?.updatedActivityEventData,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SingleActivityResult)
